import eyecare from "assets/images/banners/home/gyno.png";
import aboutus from "assets/images/banners/about/about.png";
import facility from "assets/images/banners/facility/gyno.png";
import info from "assets/images/banners/info/gyno.png";
import facility2 from "assets/images/banners/facility/wavelight.png";

export const data = {
  id: "gyno",
  label: "Gynaecology",
  banner: 
    "Best Gynaecology Hospital in Chennai - Expert Women’s Healthcare || Safe, Reliable, and Advanced Gynaecology Care",
  bannerSize: ["3.25rem", "2.375rem"],

  bannerImg: eyecare,
  aboutImg: aboutus,
  title: "Best Gynaecologist in Chennai | Maternity & Fertility Care",
  description: "Looking for the best gynaecologist in Chennai? Amrit Hospitals offers expert maternity, fertility, PCOS & laparoscopic care with experienced specialists.",
  keyword: "best gynecologist in Chennai, gynaecologist in chennai, best gynecologist chennai, gynecologist hospital in chennai, best gyno in chennai, best obstetrician in chennai, best gynaecologist hospital in chennai, best gynecologist, good gynecologist in chennai, best gynecologist hospital in chennai, top gynaecologist in chennai, fertility hospital in chennai, best gyn, fertility hospital in chennai, best laparoscopic surgeon in india",
   url: "https://www.amrithospitals.com/department/gyno",
  Imageme: "https://www.amrithospitals.com/static/media/gyno.1dd2c4c1d172ebd7f694.png",
  about: [
    {
      text: "48+",
      subText: "Years of Experience",
    },
    {
      text: "2 Lac+",
      subText: "Surgeries",
    },
    {
      text: "4.8 Lac+",
      subText: "Happy Patients",
    },
    {
      text: "30,000+",
      subText: "Babies Born",
    },
  ],
  facilityImg: facility,
  infoImg: info,
  info: {
    heder: "C-Section Surgery",
    subheader: "Expert Care for a Safe Delivery",
    point1: "EXPERT SURGEONS , ADVANCED TECHNIQUES",
    point2: "SAFE RECOVERY, COMPASSIONATE CARE",
  },
  facility: {
    mainHeader: "Empowering Women’s Health with Advanced Gynaecology Care",
    subHeader: "Best Gynaecologist in Chennai for Expert Women’s Care",
    content:
      "Searching for the best gynaecologist hospital in Chennai? Our skilled specialists and top gynaecologists provide advanced maternity, fertility, and women’s healthcare services. As a trusted fertility hospital in Chennai, we offer state-of-the-art treatments with compassionate and personalized care to ensure safety, comfort, and better health outcomes at every stage.",
  },
   
  serviceHeader: "Expert Gynaecology Care Services in Chennai",
  services: [
      {
        id: "generalPediatrics",
        label: "Comprehensive Maternity Care",
        content:
          "Welcome motherhood with confidence at the best gynaecologist hospital in Chennai. Our best obstetrician and experienced specialists provide personalized prenatal care, safe delivery, and postnatal support for the well-being of both mother and baby.",
      },
      {
        id: "pediatricEmergencyCare",
        label: "Latest Fertility Treatments",
        content:
          "Facing infertility problems? Our expert professionals provide IVF, IUI, and customized treatments via cutting-edge reproductive technology, allowing couples to give birth safely in the best gynaecology hospital in Chennai.",
      },
      {
        id: "pediatricVaccinesPreventiveCare",
        label: "Treatment of PCOS and Endometriosis",
        content:
          "Are you suffering from hormonal imbalance? Our skilled gynaecologists offer advanced endometriosis and PCOS treatment with long-lasting relief and improved reproductive health through personalized care and innovative medical therapy.",
      },
      {
        id: "pediatricSurgeryRecovery",
        label: "Safe & Painless Delivery Options",
        content:
          "Relish worry-free delivery with quality care. We offer painless delivery, C-section, and natural postpartum care to make your experience in the best gynaecology hospital in Chennai stress-free.",
      },
      {
        id: "childDevelopmentGrowthMonitoring",
        label: "Preventive Women's Health Checkups",
        content:
          "Stay ahead of your health with periodic check-ups, pap smears, breast cancer screening, and hormonal assessment by the finest gynaecologists for early diagnosis and total care in every phase of life.",
      },
      {
        id: "pediatricNeurologyCare",
        label: "Minimal Discomfort Laparoscopic Procedures",
        content:
          "Require specialized surgery? Our Chennai best Gynaecologists are experts at laparoscopic surgeries for fibroids, ovarian cysts, and endometriosis for minimal pain, rapid recovery, and improved safety for optimal healthcare.",
      },
      {
        id: "pediatricCardiologyServices",
        label: "Menopause & Hormone Health Care",
        content:
          "Experiencing menopause symptoms? Our experts offer hormone therapy, lifestyle counseling, and personalized treatments to alleviate symptoms without sacrificing long-term health and well-being.",
      },
      {
        id: "pediatricDermatologyCare",
        label: "Teenage & Adolescent Gynaecology Care",
        content:
          "Teenage girls must also be given special care. Our well-experienced gyanecologists guide them through puberty, menstruation, immunization, and reproductive health in general and bring them to healthy adulthood.",
      },
    ],
  bestPediatricServices: {
    heading: "Best Gynaecology Services in Chennai",
    services: [
      {
        id: "generalPediatrics",
        label: "1. Comprehensive Maternity Care",
        content:
          "Welcome motherhood with confidence at Chennai's best hospital. Our best gynaecologists offer personalized prenatal care, safe delivery, and post-delivery care to ensure the best for you and your baby.",
      },
      {
        id: "pediatricEmergencyCare",
        label: "2. Latest Fertility Treatments",
        content:
          "Facing infertility problems? Our expert professionals provide IVF, IUI, and customized treatments via cutting-edge reproductive technology, allowing couples to give birth safely in the best gynaecology hospital in Chennai.",
      },
      {
        id: "pediatricVaccinesPreventiveCare",
        label: "3. Treatment of PCOS and Endometriosis",
        content:
          "Are you suffering from hormonal imbalance? Our skilled gynaecologists offer advanced endometriosis and PCOS treatment with long-lasting relief and improved reproductive health through personalized care and innovative medical therapy.",
      },
      {
        id: "pediatricSurgeryRecovery",
        label: "4. Safe & Painless Delivery Options",
        content:
          "Relish worry-free delivery with quality care. We offer painless delivery, C-section, and natural postpartum care to make your experience in the best gynaecology hospital in Chennai stress-free.",
      },
      {
        id: "childDevelopmentGrowthMonitoring",
        label: "5. Preventive Women's Health Checkups",
        content:
          "Stay ahead of your health with periodic check-ups, pap smears, breast cancer screening, and hormonal assessment by the finest gynaecologists for early diagnosis and total care in every phase of life.",
      },
      {
        id: "pediatricNeurologyCare",
        label: "6. Minimal Discomfort Laparoscopic Procedures",
        content:
          "Require specialized surgery? Our Chennai best Gynaecologists are experts at laparoscopic surgeries for fibroids, ovarian cysts, and endometriosis for minimal pain, rapid recovery, and improved safety for optimal healthcare.",
      },
      {
        id: "pediatricCardiologyServices",
        label: "7. Menopause & Hormone Health Care",
        content:
          "Experiencing menopause symptoms? Our experts offer hormone therapy, lifestyle counseling, and personalized treatments to alleviate symptoms without sacrificing long-term health and well-being.",
      },
      {
        id: "pediatricDermatologyCare",
        label: "8. Teenage & Adolescent Gynaecology Care",
        content:
          "Teenage girls must also be given special care. Our well-experienced gyanecologists guide them through puberty, menstruation, immunization, and reproductive health in general and bring them to healthy adulthood.",
      },
    ],
  },
  faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.  Why choose Amrit Hospitals for the best gynaecologist in Chennai?",
        content:
          "Amrit Hospitals is home to some of the best gynaecologists in Chennai, offering advanced treatments, personalized care, and modern medical technology. The hospital focuses on patient safety, accurate diagnosis, and comprehensive women’s healthcare services.",
      },
      {
        label: "2. What fertility treatments are available at Amrit Hospitals in Chennai?",
        content:
          "Amrit Hospitals offers advanced fertility treatments in Chennai, including diagnostic evaluations, ovulation induction, hormonal therapy, and assisted reproductive techniques. Our specialists provide customized treatment plans to improve success rates.",
      },
      {
        label: "3. How do the best gynaecologists in Chennai treat PCOS?",
        content:
          "The best gynaecologists in Chennai treat PCOS through a combination of lifestyle management, medications, and hormonal therapy. At Amrit Hospitals, treatment plans are tailored to each patient’s condition to ensure effective long-term results.",
      },
      {
        label: "4. When should I consult a gynaecologist in Chennai?",
        content:
          "You should consult a gynaecologist in Chennai if you experience irregular periods, pelvic pain, hormonal imbalance, pregnancy concerns, or difficulty in conceiving. Early consultation helps in timely diagnosis and treatment.",
      },
      {
        label: "5. What services are provided by a gynaecologist in Chennai at Amrit Hospitals?",
        content:
          "Gynaecologists at Amrit Hospitals provide a wide range of services including pregnancy care, infertility treatment, laparoscopic surgeries, PCOS management, menopause care, and preventive screenings such as pap smear tests.",
      },
      {
        label: "6. Are laparoscopic surgeries safe for gynaecological conditions in Chennai?",
        content:
          "Yes, laparoscopic surgeries are safe and minimally invasive procedures used to treat conditions like ovarian cysts, fibroids, and endometriosis. At Amrit Hospitals, experienced specialists ensure faster recovery and minimal discomfort.",
      },
      {
        label: "7. How can I book an appointment with the best gynaecologist in Chennai?",
        content:
          "You can book an appointment with the best gynaecologist in Chennai at Amrit Hospitals through their website, by calling the hospital, or by visiting the facility directly for consultation.",
      },
    ],
  },
};
